import { Box, Typography } from '@mui/material';
import { BaseAccordion } from '../../../../../Accordion/BaseAccordion';
import { ColumnMapping } from '../InstrumentIdentifiers/components/ColumnMapping/ColumnMapping';
import { ValidationBadge } from '../../ValidationBadge/ValidationBadge';
import { CustomAutocomplete } from '../../../../../Infra/CustomAutocomplete/CustomAutocomplete';
import { SingleColumnWithDateSectionProps } from './types';
import { useSingleColumnWithDateSection } from './useSingleColumnWithDateSection';
import './SingleColumnWithDateSection.scss';

export const SingleColumnWithDateSection = (
  props: SingleColumnWithDateSectionProps
) => {
  const {
    templateId,
    instrumentType,
    sectionId,
    availableHeaders = [],
    expanded,
    onChange,
    title,
  } = props;
  const {
    dateFormatOptions,
    selectedDateFormat,
    handleDateFormatChange,
    validationResult,
  } = useSingleColumnWithDateSection(props);

  return (
    <BaseAccordion
      title={title}
      expanded={expanded}
      onChange={onChange}
      className="singleColumnWithDateSection"
      badge={<ValidationBadge validationResult={validationResult} />}
    >
      <ColumnMapping
        templateId={templateId}
        instrumentType={instrumentType}
        sectionId={sectionId}
        availableHeaders={availableHeaders}
        singleMode={true}
      />

      <Box className="dateFormatContainer">
        <Typography variant="subtitle2" sx={{ textAlign: 'left' }}>
          DATE FORMAT
        </Typography>
        <CustomAutocomplete
          sx={{ width: '300px' }}
          value={
            dateFormatOptions.find(opt => opt.value === selectedDateFormat) ||
            null
          }
          onChange={(_, newValue) =>
            handleDateFormatChange(newValue?.value || '')
          }
          options={dateFormatOptions}
          getOptionLabel={option => option.label}
          renderOption={(props, option) => (
            <li {...props}>
              <Box className="formatOption">
                <Typography variant="body2">{option.label}</Typography>
                <Typography variant="caption" color="text.secondary">
                  Example: {option.example}
                </Typography>
              </Box>
            </li>
          )}
          placeholder="Select format..."
          ListboxProps={{
            style: { maxHeight: 300 },
          }}
          className="dateFormatSelect"
        />
      </Box>
    </BaseAccordion>
  );
};
